import { render, staticRenderFns } from "./VgmWeighingMethodHeader.vue?vue&type=template&id=6597dedc&scoped=true&"
import script from "./VgmWeighingMethodHeader.vue?vue&type=script&lang=js&"
export * from "./VgmWeighingMethodHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6597dedc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6597dedc')) {
      api.createRecord('6597dedc', component.options)
    } else {
      api.reload('6597dedc', component.options)
    }
    module.hot.accept("./VgmWeighingMethodHeader.vue?vue&type=template&id=6597dedc&scoped=true&", function () {
      api.rerender('6597dedc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/components/booking/vgm/VgmWeighingMethodHeader.vue"
export default component.exports